<template>
  <search @search="search" v-model="searchValue" @clear="clearValue">
    <div class="content" slot="content">
      <van-sticky>
        <div class="navTabBar">
          <div
            class="nav-item"
            :class="{ current: filterIndex === 0 }"
            @click="tabClick(0)"
          >
            综合排序
          </div>
          <div
            class="nav-item"
            :class="{ current: filterIndex === 1 }"
            @click="tabClick(1)"
          >
            销量优先
          </div>
          <div
            class="nav-item"
            :class="{ current: filterIndex === 2 }"
            @click="tabClick(2)"
          >
            <span>价格</span>
            <div class="p-box">
              <span
                :class="{ active: priceOrder === 1 && filterIndex === 2 }"
                class="yticon icon-shang"
              ></span>
              <span
                :class="{ active: priceOrder === 2 && filterIndex === 2 }"
                class="yticon icon-shang xia"
              ></span>
            </div>
          </div>
          <span
            class="cate-item yticon icon-fenlei1"
            @click="toggleCateMask"
          ></span>
        </div>
      </van-sticky>
      <my-refresh-more
        ref="refresh"
        v-model="list"
        :pageSize="10"
        :getList="getList"
        :getParams="getParams"
        :params="{ fid, sid, tid, filterIndex, priceOrder, searchValue }"
      >
        <div slot="list" class="goods-list">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="goods-item"
            @click="navToDetailPage(item)"
          >
            <div class="image-wrapper">
              <van-image
                lazy-load
                :src="item.pictureUrl"
                class="picture-wrapper"
              />
              <span class="isHot" v-if="item.isHot == 1">热卖</span>
              <span class="isNew" v-if="item.isNew == 1">新品</span>
              <span class="isRecommend" v-if="item.isRecommend == 1">推荐</span>
            </div>
            <span class="title clamp">{{ item.name }}</span>
            <div
              class="title clamp"
              style="color: red; font-size: 14px; margin: 5px 0"
            >
              {{ item.promotionName }}
            </div>
            <div class="price-box w-100">
              <div class="price">
                <span>{{ item.price }}</span>
                <span v-if="item.isIntegral === 1" style="margin-left: 3px"
                  >+ {{ item.mostIntegralCanUse }}积分</span
                >
                <span class="m-price">¥{{ item.nominalPrice }}</span>
                <van-tag v-if="item.activity == 1" type="danger"
                  >团购价</van-tag
                >
                <van-tag v-if="item.activity == 2" type="danger"
                  >限时折扣</van-tag
                >
              </div>
              <van-button
                v-if="item.activity == 1 && item.activityState !== 0"
                size="small"
                round
                type="primary"
                style="width:80px"
                >去拼团</van-button
              >
              <span v-else style="flex:1;text-align: right">已售 {{ item.salesVolume }}</span>
            </div>
            <div class="pro-box" v-if="item.joined && item.activityType == 1">
              <div class="progress-box">
                <progress
                  :percent="(item.activitySalesVolume / item.quantity) * 100"
                  activeColor="#fa436a"
                  active
                  stroke-width="6"
                />
              </div>
              <span>{{ item.activitySalesVolume }}/{{ item.quantity }}</span>
            </div>
            <div class="pro-box" v-if="item.joined && item.activityType == 2">
              <span class="activspan">下单可抽奖</span>
            </div>
          </div>
        </div>
      </my-refresh-more>
      <van-popup
        v-model="showPopup"
        position="right"
        :style="{ height: '100%', width: '315px' }"
      >
        <div class="cate-list">
          <div v-for="fItem in cateList" :key="fItem.id">
            <div
              class="cate-item one"
              :class="{ active: fItem.id == fid }"
              @click="changeCate(fItem)"
            >
              {{ fItem.name }}
            </div>
            <div class="bottom-border"></div>
            <div v-for="sItem in fItem.children" :key="sItem.id">
              <div
                class="cate-item two"
                :class="{ active: sItem.id == sid }"
                @click="changeCate(fItem, sItem)"
              >
                {{ sItem.name }}
              </div>
              <div class="bottom-border"></div>
              <div class="float-box" v-if="sItem.children.length > 0">
                <div
                  v-for="tItem in sItem.children"
                  :key="tItem.id"
                  class="three float-item"
                  :class="{ active: tItem.id == tid }"
                  @click="changeCate(fItem, sItem, tItem)"
                >
                  {{ tItem.name }}
                </div>
              </div>
              <div v-if="sItem.children.length > 0" class="bottom-border"></div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </search>
</template>

<script>
import {myMixins} from '@/mixins'
import search from "@/views/onlinePages/base.vue";
export default {
  components: {
    search,
  },
    mixins:[myMixins],
  data() {
    return {
      searchValue: "",
      showPopup: false, //分类面板展开状态
      refreshing: false,
      loading: false,
      finished: false,
      filterIndex: 0,
      priceOrder: 0, //1 价格从低到高 2价格从高到低
      cateList: [],
      list: [],
      fid: 0, //一级Id
      sid: 0, //二级Id
      tid: 0, //三级Id,
      type: "",
    };
  },
  created() {
    let query = this.$route.query;
    console.log(query);
    this.fid = query.fid * 1;
    this.sid = query.sid * 1;
    this.tid = query.tid;
    this.title = query.title;
    this.type = query.type;
    this.setTitle();
    this.loadCateList();
  },
  methods: {
    clearValue() {
      this.searchValue = "";
      this.$refs.refresh.refreshList();
    },
    search(value) {
      this.searchValue = value;
      this.$refs.refresh.refreshList();
    },
    setTitle() {
      if (this.title) {
        document.title = this.title;
      }
    },
    //加载分类
    loadCateList() {
      let url = "";
      if (this.type == 1) {
        url = this.$http.pathMap.categoryTree;
      } else if (this.type == 2) {
        url = this.$http.pathMap.sortTree;
      } else {
        url = this.$http.pathMap.virtualTree;
      }
      this.$http.request(url, "get").then((res) => {
        this.cateList = res.data;
      });
    },
    getParams() {
      let { fid, sid, tid, filterIndex, priceOrder, searchValue } = this;
      return {
        fid,
        sid,
        tid,
        filterIndex,
        priceOrder,
        searchValue,
      };
    },
    getList(page, size, param) {
      let { fid, sid, tid, filterIndex, priceOrder, searchValue } = param;

      let id = tid ? tid : sid * 1 ? sid * 1 : fid * 1;
      let params = {
        categoryId: id,
        page: page,
        size: size,
        name: searchValue,
      };
      console.log('params',params);
      if (filterIndex == 1) {
        params.salesVolumeSort = "DESC";
      }
      if (filterIndex == 2) {
        if (priceOrder == 1) {
          params.priceSort = "DESC";
        } else {
          params.priceSort = "ASC";
        }
      }
      let url = "";
      if (this.type == 1 || this.type == 4) {
        if (this.type == 4) {
          params.activity = 1;
        }
        url = this.$http.pathMap.productList;
      } else if (this.type == 2) {
        url = this.$http.pathMap.courseLis;
      } else {
        url = this.$http.pathMap.virtualList;
      }
      return new Promise((resolve, reject) => {
        this.$http.request(url, "get", params).then((res) => {
          let data = res.data;
          data.list.forEach((item) => {
            let pictures = item.picture;
            item.pictureUrl =
              pictures && pictures.length > 0 ? pictures[0] : "";
          });
          resolve(data);
        });
      });
    },
    //筛选点击
    tabClick(index) {
      if (this.filterIndex === index && index !== 2) {
        return;
      }
      this.filterIndex = index;
      if (index === 2) {
        this.priceOrder = this.priceOrder === 1 ? 2 : 1;
      } else {
        this.priceOrder = 0;
      }
      this.$refs.refresh.refreshList();
    },
    //显示分类面板
    toggleCateMask() {
      this.showPopup = !this.showPopup;
    },
    //分类点击
    changeCate(fitem, sitem, titem) {
      this.fid = fitem ? fitem.id : 0;
      this.sid = sitem ? sitem.id : 0;
      this.tid = titem ? titem.id : 0;
      this.title = titem ? titem.name : sitem ? sitem.name : fitem.name;
      this.setTitle();
      this.toggleCateMask();
      this.$refs.refresh.refreshList();
    },
    //详情
    navToDetailPage(item) {
      let id = item.id;
      if (item.type && item.type == 1) {
        this.$router.push({
          path: "/onlinePages/course/course",
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: "/pages/product/product",
          query: {
            id,
            type: this.type,
            activityState: item.activityState,
          },
        });
      }
    },
    stopPrevent() {},
  },
};
</script>

<style lang="scss" scoped>
page,
.content {
  background: $page-color-base;
}
.search-box {
  height: 45px;
  z-index: 21;
  width: 100%;
  padding: 2px 15px;

  input {
    height: 35px;

    flex: 1;
    border-radius: 17px;
    background-color: rgb(248, 248, 248);
    padding: 5px 15px;
  }

  span {
    font-size: 15px;
    color: grey;
    height: 30px;
    line-height: 30px;
    padding-left: 5px;
  }
}
.pro-box {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: $uni-font-size-sm;
  color: $uni-font-size-base;
  padding-right: 5px;
}

.progress-box {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 4px;
}

.navTabBar {
  display: flex;
  width: 100%;
  height: 40px;
  background: #fff;
  box-shadow: 0 2upx 10upx rgba(0, 0, 0, 0.06);
  z-index: 10;

  .nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 15px;
    color: $font-color-dark;
    position: relative;

    &.current {
      color: $base-color;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 60px;
        height: 0;
        border-bottom: 2px solid $base-color;
      }
    }
  }

  .p-box {
    display: flex;
    flex-direction: column;

    .yticon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 7x;
      line-height: 1;
      margin-left: 2px;
      font-size: 13px;
      color: #888;

      &.active {
        color: $base-color;
      }
    }

    .xia {
      transform: scaleY(-1);
    }
  }

  .cate-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 40px;
    position: relative;
    font-size: 22px;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-left: 1px solid #ddd;
      width: 0;
      height: 18px;
    }
  }
}

/* 分类 */

.cate-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .cate-item {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 15px;
    font-size: 14px;
    color: #555;
    position: relative;
  }

  .one {
    color: #303133;
    font-size: 15px;
    background: #f8f8f8;
  }

  .two {
    color: #303133;
    font-size: 15px;
    padding-left: 30px;
  }

  .three {
    color: #303133;
    font-size: 15px;
  }

  .active {
    color: $base-color;
    border-color: $base-color !important;
  }
}

.float-box {
  width: 100%;
  overflow: hidden;
  padding-left: 25px;
  color: #555;

  .float-item {
    float: left;
    display: flex;
    align-items: center;
    height: 30px;
    margin: 5px;
    padding: 0 10px;
    font-size: 14px;
    position: relative;
    border: 1px solid #e4e7ed;
  }
}

.bottom-border {
  border-bottom: 1px solid #e4e7ed;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

/* 商品列表 */
.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 15px;
  background: #fff;

  .goods-item {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 48%;
    padding-bottom: 20px;

    &:nth-child(2n + 1) {
      margin-right: 4%;
    }
  }

  .image-wrapper {
    width: 100%;
    height: 165px;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    span {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      padding: 0 5px;
      color: #fff;
      font-size: 14px;
      background: #f56c6c;
    }
    .picture-wrapper {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }

  .title {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
    line-height: 20px;
  }

  .price-box {
    display: flex;
    align-items: center;
    padding-right: 5px;
    font-size: 12px;
    color: $font-color-light;
  }

  .price {
    font-size: $uni-font-size-lg;
    color: var(--theme-font-color);
    line-height: 1;

    &:before {
      content: "￥";
      font-size: 13px;
    }
    .m-price {
      margin: 0 6px;
      color: $font-color-light;
      text-decoration: line-through;
      font-size: 12px;
    }
  }
  .activspan {
    font-size: 10px !important;
    font-size: $uni-font-size-lg;
    color: var(--theme-font-color);
    line-height: 1;
  }
}
.van-tag {
  transform: scale(0.7);
}
</style>
